import { useSyncExternalStore } from 'react';
import { SaxaFrame, PulsingFrame } from './saxa-avatar';

interface SaxaAvatarProps {
  size?: 'sm' | 'md' | 'lg';
  pulse?: boolean;
  expression?: string;
  mode?: string;
  /** Force dark/light palette. When omitted, follows the page theme (.dark class). */
  dark?: boolean;
  className?: string;
}

const PX = { sm: 32, md: 40, lg: 56 } as const;

// Reactive theme detection via MutationObserver on <html> class list
function subscribeToDarkMode(callback: () => void) {
  const observer = new MutationObserver(callback);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  return () => observer.disconnect();
}

function getIsDark() {
  return document.documentElement.classList.contains('dark');
}

export function SaxaAvatar({
  size = 'md',
  pulse = false,
  expression = 'idle',
  mode = 'ai',
  dark,
  className = '',
}: SaxaAvatarProps) {
  const themeDark = useSyncExternalStore(subscribeToDarkMode, getIsDark);
  const isDark = dark ?? themeDark;
  const px = PX[size];

  return (
    <div className={className}>
      <PulsingFrame animate={pulse}>
        <SaxaFrame
          size={px}
          expression={expression}
          mode={mode}
          showBrackets={mode === 'runes'}
          dark={isDark}
        />
      </PulsingFrame>
    </div>
  );
}
